import React, { useEffect } from "react";
import { styled } from '@mui/system';
import { v4 as uuidv4 } from 'uuid';
import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../styles/theme/aistheme.css";
import "../../styles/theme/sharedThemeOverride.css";
import { MainViewInstruction, changeMainView } from "../../globals/observables/main/mainViewObservable";
import { AuthSessionState } from "../../globals/data/authSessionState";
import { AuthSessionStatus, updateAuthSessionState } from "../../globals/observables/IMAuthFlow/imAuthFlowObservable";



const GeneralButtonStyle = {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    color: "black",
    height: "35px",
    marginTop: "auto",
    marginBottom: "auto",
    width: "35px",
    backgroundColor: "gray",
    maxHeight: "35px !Important",
    maxWidth: "35px  !Important",
    minHeight: "35px !Important",
    minWidth: "35px  !Important",
    padding: "0px"
};


const WrapperContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: pink;
    flex-basis: 100%;
    `
);



const OutterBoxContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: lightblue;

    // min-width:500px;
    // min-height:500px;

    // margin-left:auto;
    // margin-right:auto;
    // margin-top:auto;
    // margin-bottom:auto;
    
    `
);


interface AuthPayload{
    userProfileRef:string,
    email:string,
    token:string,
    hint:string
}






interface HeaderProps {

}


function AuthPresenter(props: HeaderProps) {

    const storedValue = uuidv4();
    
    //Deployed
    const externalPageURL = 'https://auth.aistudio.com/?sessionid=' + storedValue + '&authhint=' + 'email' + '&mode=portal'; 

    //Local Testing 
    //const externalPageURL = 'http://localhost:3000/?sessionid=' + storedValue + '&authhint=' + 'email' + '&mode=portal';

    useEffect(() => {
        // Add event listener to handle messages from the iframe
        const handleMessage = (event) => {

            console.log('Origin=>', event.origin);

            if (event.origin !== 'http://localhost:3000' && event.origin !== 'https://auth.aistudio.com') {
                return;
            }

            // Access the data sent from the iframe
            const receivedData = event.data;

            // Do something with the received data
            console.log('Received data from iframe:', receivedData);

            var sourceObj = JSON.parse(receivedData.data) as AuthSessionState;
            
            updateAuthSessionState(
                AuthSessionStatus.SUUCCESS,
                sourceObj.userProfileRef,
                sourceObj.email,
                sourceObj.token
            )
        };

        // Add the event listener when the component mounts
        window.addEventListener('message', handleMessage);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []); // Empty dependency array ensures the effect runs once on mount


    const handleDoAuthTemp = async () => {
        await changeMainView(
            MainViewInstruction.LANDING
        );


    }

    const handleIframeLoad = () => {

    }

    return (
        <WrapperContainer id="auth presenter WrapperContainer">

            <OutterBoxContainer id="OutterBoxContainer">

                <iframe
                    src={externalPageURL}
                    title="External Page"
                    width="100%"
                    height="100%" // Adjust the height based on your requirement
                    onLoad={handleIframeLoad}
                />

            </OutterBoxContainer>

        </WrapperContainer>

    )
}


export default AuthPresenter;